import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import translate from '../../translate'
import { isRequired } from '../../../helpers'

const style = {
  marginTop: 5,
}

const FamilyMembersInformation = ({ fields }) => {
  return (
    <GridContainer noPadding style={style}>
      <Grid>
        {(!!fields.IND_FamilyMembers_Total || !!fields.FemaleFamily || !!fields.InvalidFamily) && (
          <Grid.Row style={{ padding: 0 }} columns={1}>
            <Grid.Column>
              <FormLayout labelFieldProportions="0:16">
                <FormLayout
                  label={translate('lbl_total_members')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_FamilyMembers_Total}
                >
                  <FormField
                    name="IND_FamilyMembers_Total"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_FamilyMembers_Total)}
                    min={fields.IND_FamilyMembers_Total && fields.IND_FamilyMembers_Total.MinValue}
                    max={fields.IND_FamilyMembers_Total && fields.IND_FamilyMembers_Total.MaxValue}
                  />
                </FormLayout>
                <FormLayout
                  label={translate('lbl_female_members')}
                  labelFieldProportions="10:6"
                  visible={!!fields.FemaleFamily}
                >
                  <FormField
                    name="FemaleFamily"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.FemaleFamily)}
                    min={fields.FemaleFamily && fields.FemaleFamily.MinValue}
                    max={fields.FemaleFamily && fields.FemaleFamily.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_invalidfamily')}
                  labelFieldProportions="10:6"
                  visible={!!fields.InvalidFamily}
                >
                  <FormField
                    name="InvalidFamily"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.InvalidFamily)}
                    min={fields.InvalidFamily && fields.InvalidFamily.MinValue}
                    max={fields.InvalidFamily && fields.InvalidFamily.MaxValue}
                  />
                </FormLayout>
              </FormLayout>
            </Grid.Column>
          </Grid.Row>
        )}
        {(!!fields.IND_FamilyMembers_Bus || !!fields.IND_Children || !!fields.OldFamily) && (
          <Grid.Row style={{ padding: 0 }}>
            <Grid.Column>
              <FormLayout labelFieldProportions="0:16">
                <FormLayout
                  label={translate('lbl_family_members_bus')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_FamilyMembers_Bus}
                >
                  <FormField
                    name="IND_FamilyMembers_Bus"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_FamilyMembers_Bus)}
                    min={fields.IND_FamilyMembers_Bus && fields.IND_FamilyMembers_Bus.MinValue}
                    max={fields.IND_FamilyMembers_Bus && fields.IND_FamilyMembers_Bus.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_children')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Children}
                >
                  <FormField
                    name="IND_Children"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Children)}
                    min={fields.IND_Children && fields.IND_Children.MinValue}
                    max={fields.IND_Children && fields.IND_Children.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_oldfamily')}
                  labelFieldProportions="10:6"
                  visible={!!fields.OldFamily}
                >
                  <FormField
                    name="OldFamily"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.OldFamily)}
                    min={fields.OldFamily && fields.OldFamily.MinValue}
                    max={fields.OldFamily && fields.OldFamily.MaxValue}
                  />
                </FormLayout>
              </FormLayout>
            </Grid.Column>
          </Grid.Row>
        )}
        {(!!fields.IND_Dependants || !!fields.IND_Dependants_Female || !!fields.IND_Dependants_IDP_Total) && (
          <Grid.Row style={{ padding: 0 }} columns={1}>
            <Grid.Column>
              <FormLayout labelFieldProportions="0:16">
                <FormLayout label={translate('lbl_dep')} labelFieldProportions="10:6" visible={!!fields.IND_Dependants}>
                  <FormField
                    name="IND_Dependants"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Dependants)}
                    min={fields.IND_Dependants && fields.IND_Dependants.MinValue}
                    max={fields.IND_Dependants && fields.IND_Dependants.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_dep_female')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Dependants_Female}
                >
                  <FormField
                    name="IND_Dependants_Female"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Dependants_Female)}
                    min={fields.IND_Dependants_Female && fields.IND_Dependants_Female.MinValue}
                    max={fields.IND_Dependants_Female && fields.IND_Dependants_Female.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_dep_idp')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Dependants_IDP_Total}
                >
                  <FormField
                    name="IND_Dependants_IDP_Total"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Dependants_IDP_Total)}
                    min={fields.IND_Dependants_IDP_Total && fields.IND_Dependants_IDP_Total.MinValue}
                    max={fields.IND_Dependants_IDP_Total && fields.IND_Dependants_IDP_Total.MaxValue}
                  />
                </FormLayout>
              </FormLayout>
            </Grid.Column>
          </Grid.Row>
        )}
        {(!!fields.IND_Employed_Total || !!fields.IND_Employed_Female || !!fields.IND_Employed_IDP_Total) && (
          <Grid.Row style={{ padding: 0 }} columns={1}>
            <Grid.Column>
              <FormLayout labelFieldProportions="0:16">
                <FormLayout
                  label={translate('lbl_empl')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Employed_Total}
                >
                  <FormField
                    name="IND_Employed_Total"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Employed_Total)}
                    min={fields.IND_Employed_Total && fields.IND_Employed_Total.MinValue}
                    max={fields.IND_Employed_Total && fields.IND_Employed_Total.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_empl_female')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Employed_Female}
                >
                  <FormField
                    name="IND_Employed_Female"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Employed_Female)}
                    min={fields.IND_Employed_Female && fields.IND_Employed_Female.MinValue}
                    max={fields.IND_Employed_Female && fields.IND_Employed_Female.MaxValue}
                  />
                </FormLayout>

                <FormLayout
                  label={translate('lbl_empl_idp')}
                  labelFieldProportions="10:6"
                  visible={!!fields.IND_Employed_IDP_Total}
                >
                  <FormField
                    name="IND_Employed_IDP_Total"
                    type="number"
                    maxLength="3"
                    required={isRequired(fields.IND_Employed_IDP_Total)}
                    min={fields.IND_Employed_IDP_Total && fields.IND_Employed_IDP_Total.MinValue}
                    max={fields.IND_Employed_IDP_Total && fields.IND_Employed_IDP_Total.MaxValue}
                  />
                </FormLayout>
              </FormLayout>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </GridContainer>
  )
}

export default FamilyMembersInformation
